<!-- 课程信息 -->
<template>
    <div class="courseMsg">
        <div class="handleBtnBox">
            <el-button type="primary" icon="el-icon-plus" @click="handleAddSection">添加新章</el-button>
            <el-button icon="el-icon-arrow-left" @click="handleReturnCourse">返回课程</el-button>
        </div>
        <div class="courseMsgContent" v-loading="contentLoading">
            <div class="noData" v-if="!courseSectionTree.length">
                <img class="noDataImg" :src="require('@/assets/measAssets/image/common/no_data.png')" alt="">
                <div class="noDataTips">暂无数据</div>
            </div>
            <div v-else class="sectionBox">
                <el-collapse accordion class="section" v-model="openSectionItem">
                    <el-collapse-item class="sectionItem" :name="item.sectioncode" v-for="(item, index) in courseSectionTree" :key="index">
                        <template slot="title">
                            <div class="sectionTitleHandleBox">
                                <div class="sectionTitle">{{item.sectionname}}</div>
                                <div class="sectionHandleBox" @click.stop="() => {}">
                                    <div class="sectionHandleItem color-brand pointer" @click="saveCourseSectionIndex(item, index, 'up')" v-if="index !== 0">上移</div>
                                    <div class="sectionHandleItem color-brand pointer" @click="saveCourseSectionIndex(item, index, 'down')" v-if="index !== courseSectionTree.length - 1">下移</div>
                                    <div class="sectionHandleItem color-brand pointer" @click="handleEditSection(item)">编辑</div>
                                    <div class="sectionHandleItem color-brand pointer" @click="handleDeleteSection(item, index)">删除</div>
                                    <div class="sectionHandleItem color-brand pointer" @click="handleAddNode(item)">添加新节</div>
                                </div>
                            </div>
                        </template>
                        <div class="noData" v-if="!item.sectiontasklist.length">
                            <img class="noDataImg" :src="require('@/assets/measAssets/image/common/no_data.png')" alt="">
                            <div class="noDataTips">暂无数据</div>
                        </div>
                        <div class="taskList" v-else>
                            <div class="taskItem" v-for="(option, i) in item.sectiontasklist" :key="i">
                                <div class="taskName">{{option.taskname}}</div>
                                <div class="taskHandleBox">
                                    <div class="taskHandleItem color-brand pointer" @click="saveCourseSectionTaskIndex(item, option, i, 'up')" v-if="i !== 0">上移</div>
                                    <div class="taskHandleItem color-brand pointer" @click="saveCourseSectionTaskIndex(item, option, i, 'down')" v-if="i !== item.sectiontasklist.length - 1">下移</div>
                                    <div class="taskHandleItem color-brand pointer" @click="handleEditTask(item, option)">编辑</div>
                                    <div class="taskHandleItem color-brand pointer" @click="handleDeleteTask(item, option, i)">删除</div>
                                    <div class="taskHandleItem color-brand pointer" @click="handleInsertionTask(item, i)">插入新节</div>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <MaintainSection @maintainSectionSuccess="getCourseSectionTree" ref="maintainSection" />
        <MaintainTask @maintainTaskSuccess="getCourseSectionTree" ref="maintainTask" />
    </div>
</template>

<script>
import {getCourseSectionTree, updateSectionStatus, saveCourseSectionIndex, saveCourseSectionTaskIndex, updateSectionTaskStatus} from '@/api/measApi/courseManage.js'
import MaintainSection from './components/maintainSection.vue'
import MaintainTask from './components/maintainTask.vue'
export default {
    data() {
        return {
            params: {
                code: this.$route.query.courseCode
            },
            contentLoading: false,
            courseSectionTree: [],
            openSectionItem: ''
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getCourseSectionTree()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        // 新增章
        handleAddSection() {
            this.$refs.maintainSection.handleOpen(this.params.code, '', '')
        },
        // 返回课程
        handleReturnCourse() {
            this.$router.back()
            // this.$router.push({name: 'CourseList'})
        },
        // 获取章节树列表
        getCourseSectionTree() {
            this.contentLoading = true
            getCourseSectionTree(this.params).then(res => {
                if (res.code === '000') {
                    this.contentLoading = false
                    this.courseSectionTree = res.data
                }
            })
        },
        // 编辑章
        handleEditSection(item) {
            this.$refs.maintainSection.handleOpen(this.params.code, item.sectioncode, item.sectionname)
        },
        // 删除章
        handleDeleteSection(item, index) {
            this.$confirm('删除该章后下属的节信息也将同时删除，继续吗？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'measElMessage'
            }).then(() => {
                updateSectionStatus({code: item.sectioncode}).then(res => {
                    if (res.code === '000') {
                        this.$message.success(res.msg)
                        this.courseSectionTree.splice(index, 1)
                    }
                })
            })
        },
        // 移动章节
        saveCourseSectionIndex(item, index, direction) {
            let params = {
                code: item.sectioncode,
                targetcode: ''
            }
            if (direction === 'up') {
                params.targetcode = this.courseSectionTree[index - 1].sectioncode
            } else if (direction === 'down') {
                params.targetcode = this.courseSectionTree[index + 1].sectioncode
            }
            saveCourseSectionIndex(params).then(res => {
                if (res.code === '000') {
                    this.$message.success(res.msg)
                    this.getCourseSectionTree()
                }
            })
        },
        // 添加新节
        handleAddNode(item) {
            this.$refs.maintainTask.handleOpen(item.sectioncode, '', '')
        },
        // 编辑节
        handleEditTask(section, task) {
            this.$refs.maintainTask.handleOpen(section.sectioncode, task.taskcode, '')
        },
        // 移动节
        saveCourseSectionTaskIndex(section, task, index, direction) {
            let params = {
                code: task.taskcode,
                targetcode: ''
            }
            if (direction === 'up') {
                params.targetcode = section.sectiontasklist[index - 1].taskcode
            } else {
                params.targetcode = section.sectiontasklist[index + 1].taskcode
            }
            saveCourseSectionTaskIndex(params).then(res => {
                if (res.code === '000') {
                    this.$message.success(res.msg)
                    this.getCourseSectionTree()
                }
            })
        },
        // 删除节
        handleDeleteTask(section, task, index) {
            this.$confirm('删除该节后信息将不可恢复，继续吗？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'measElMessage'
            }).then(() => {
                updateSectionTaskStatus({code: task.taskcode}).then(res => {
                    if (res.code === '000') {
                        this.$message.success(res.msg)
                        section.sectiontasklist.splice(index, 1)
                    }
                })
            })
        },
        // 插入新节
        handleInsertionTask(section, index) {
            this.$refs.maintainTask.handleOpen(section.sectioncode, '', index + 2)
        }
    },
    components: {
        MaintainSection,
        MaintainTask
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .courseMsg {
        .handleBtnBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
            .el-button {
                line-height: 34px;
            }
        }
        .courseMsgContent {
            .noData {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding-bottom: 40px;
                .noDataImg {
                    width: 200px;
                    height: 147px;
                }
                .noDataTips {
                    font-size: 12px;
                    color: #999999;
                }
            }
            .sectionBox {
                .section {
                    border: 1px solid #E4E7EC;
                    .sectionItem {
                        .el-collapse-item__header {
                            background: #F5F7FA;
                            border-bottom-color: #E4E7EC;
                            position: relative;
                            box-sizing: border-box;
                            .sectionTitleHandleBox {
                                width: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                padding: 0 30px;
                                .sectionTitle {
                                    font-size: 12px;
                                    color: #666666;
                                    width: 50%;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    font-weight: bold;
                                }
                                .sectionHandleBox {
                                    display: flex;
                                    align-items: center;
                                    cursor: default;
                                    .sectionHandleItem {
                                        font-size: 12px;
                                        &:not(:last-of-type) {
                                            margin-right: 24px;
                                        }
                                    }
                                }
                            }
                            .el-collapse-item__arrow {
                                position: absolute;
                                left: 10px;
                                color: #CCCCCC;
                                // display: none;
                            }
                        }
                        .el-collapse-item__wrap {
                            .el-collapse-item__content {
                                .noData {
                                    padding: 20px 0;
                                    border-bottom: 1px solid #E4E7EC;
                                    .noDataImg {
                                        width: 150px;
                                        height: 110px;
                                    }
                                }
                                .taskList {
                                    .taskItem {
                                        height: 48px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        padding: 0 30px 0 54px;
                                        border-bottom: 1px solid #E4E7EC;
                                        box-sizing: border-box;
                                        .taskName {
                                            width: 50%;
                                            text-overflow: ellipsis;
                                            overflow: hidden;
                                            white-space: nowrap;
                                            font-size: 12px;
                                            color: #666666;
                                        }
                                        .taskHandleBox {
                                            display: flex;
                                            align-items: center;
                                            .taskHandleItem {
                                                font-size: 12px;
                                                &:not(:last-of-type) {
                                                    margin-right: 24px;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>